export default __webpack_public_path__ + "static/og-image-e6978846b7c8e4b04a878ed3f325451f.jpg";